import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { contarAte, formatarNumero, pararAnimacoes } from '../../utils/animacoesDaPagina';

/**
 * Um número que conta de zero até o valor ao aparecer.
 *
 * ## Por que o valor também é desenhado pelo React
 *
 * O efeito escreve no nó de texto, e o React também desenha o valor no JSX.
 * Parece conflito e não é: os dois concordam no valor FINAL, e é só ele que o
 * React escreve. Se um redesenho acontecer no meio da contagem, o número
 * salta para o final -- que é o certo.
 *
 * O contrário (deixar o `span` vazio e só o efeito preencher) daria um quadro
 * em branco no lugar do número, e deixaria a tela dependendo do efeito para
 * mostrar um dado que ela já tem.
 *
 * `fontVariantNumeric: tabular-nums` existe porque sem ele os dígitos têm
 * larguras diferentes e o número TREME enquanto conta -- o que estraga
 * justamente o efeito que se queria.
 */
const NumeroAnimado = ({ valor, gsap, sx, ...resto }) => {
    const alvo = useRef(null);

    useEffect(() => {
        const animacao = contarAte(alvo.current, valor, { gsap });

        return () => pararAnimacoes(animacao);
    }, [valor, gsap]);

    return (
        <Box
            component="span"
            ref={alvo}
            sx={{ fontVariantNumeric: 'tabular-nums', ...sx }}
            {...resto}
        >
            {formatarNumero(valor)}
        </Box>
    );
};

export default NumeroAnimado;
